export const BottomSheet = ({
  title,
  onClose,
  children,
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}) => (
  <>
    <div
      className="bg-surface-overlay fixed inset-0 z-100000 backdrop-blur-sm"
      onClick={onClose}
    />
    <div className="fixed right-0 bottom-0 left-0 z-100001 flex max-h-[85vh] flex-col rounded-t-3xl bg-white px-6 pt-6 pb-8 shadow-xl">
      <div className="mb-5 flex items-center justify-between">
        <span className="text-text-strong text-[17px] font-bold">{title}</span>
        <button
          onClick={onClose}
          className="text-gray-400 transition-colors hover:text-gray-600"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div className="flex-1 overflow-y-auto">{children}</div>
    </div>
  </>
);
